export const configLonLatLayer = {
  "Name": "GridLine",
  "Renderer": "GridLine",
  "Attributes": {
    "style": {
      "Mercator": {
        "position": ["top", "right", "bottom", "left"],
        "line_color": "rgba(120,120,120,0.3)",
        "line_width": 1.0,
        // "grid_interval":10,
        "grid_interval": [
          {"zoom": 0, "interval": 30},
          {"zoom": 3, "interval": 15},
          {"zoom": 5, "interval": 10},
          {"zoom": 6, "interval": 1},
          {"zoom": 7, "interval": 1},
          {"zoom": 8, "interval": 1},
          {"zoom": 9, "interval": 1}
        ],
        "font_size": 11,
        "label_format": "type_B",
        "label_padding": 2,
        "_text_edge_color": "rgba(20,150,20,0.9)",
        "text_color": "rgba(20,150,20,0.9)",
        "label_background_color": "rgba(255,255,255,0.7)",
        "label_border_color": "rgba(0,0,0,0.3)",
        "label_border_width": 1,
      },
      "PolarStereographic": {
        "position": ["top", "right", "bottom", "left", "polar", "equator"],
        "line_color": "rgba(120,120,120,0.3)",
        "line_width": 1.0,
        // "grid_interval":10,
        "grid_interval": [
          {"zoom": 0, "interval": 30},
          {"zoom": 3, "interval": 15},
          {"zoom": 5, "interval": 10},
          {"zoom": 6, "interval": 1},
          {"zoom": 7, "interval": 1},
          {"zoom": 8, "interval": 1},
          {"zoom": 9, "interval": 1}
        ],
        "font_size": 11,
        "label_format": "type_B",
        "label_padding": 2,
        "_text_edge_color": "rgba(20,150,20,0.9)",
        "text_color": "rgba(20,150,20,0.9)",
        "label_background_color": "rgba(255,255,255,0.7)",
        "label_border_color": "rgba(0,0,0,0.3)",
        "label_border_width": 1,
      }
    }
  }
};
